import { ComponentThemeOverride } from '../../utils/types';

export const MuiDialog: ComponentThemeOverride['MuiDialog'] = {
	styleOverrides: {
		paper: {
			borderRadius: 0,
		},
	},
};
